<div id="menu-bar">
  <img id="menu-bar-logo-image" src="../../../assets/images/logo.svg" alt="logo"/>
  <div id="logout-text-wrapper" class="float-right" (mouseleave)="optionHidden = true">
    <span id="user-text" (mouseenter)="optionHidden = false" >{{username}} <i class="fa fa-user" aria-hidden="true"></i> </span>
    <ul class="menu-options" (mouseleave)="optionHidden = true" [hidden]="optionHidden">
      <li (click)="logOut()">
        Logout
      </li>
    </ul>
  </div>
</div>
